import {
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerHeader,
  DrawerBody,
  Flex,
  VStack,
  Text,
} from '@chakra-ui/react';
import { NAV_LINKS } from '../../../utils/constants';
import { IconButton } from 'src/components/atoms/IconButton';
import { Icon } from 'src/components/atoms/Icon';
import { MerkatusLogo } from 'src/components/atoms/MerkatusLogo';
import { Dispatch, SetStateAction } from 'react';
import { IS_DEV } from 'src/constants';
import { useNavigate } from 'react-router-dom';

interface MobileDrawerMenuProps {
  isOpen: boolean;
  onClose: () => void;
  onLoginClick: Dispatch<SetStateAction<boolean>>;
}

const MobileDrawerMenu: React.FC<MobileDrawerMenuProps> = ({
  isOpen,
  onClose,
  onLoginClick,
}) => {
  const navigate = useNavigate();

  return (
    <Drawer placement="left" onClose={onClose} isOpen={isOpen}>
      <DrawerOverlay />
      <DrawerContent
        bg="text.darkBlue.900"
        w={{ base: '100vw', md: '400px' }}
        maxW={{ base: '100vw', md: '400px' }}>
        <DrawerHeader borderBottom="1px solid #2C3E50" pb={1}>
          <Flex align="center" justify="space-between">
            <MerkatusLogo />
            <IconButton
              icon={<Icon iconName="close" width={3} />}
              bg="text.darkBlue.800"
              borderRadius="full"
              display="flex"
              alignItems="center"
              justifyContent="center"
              aria-label="Close menu"
              variant="ghost"
              color="white"
              onClick={onClose}
            />
          </Flex>
        </DrawerHeader>
        <DrawerBody>
          <VStack align="start" spacing={8} mt={6}>
            <Text
              color="text.lightGrey"
              fontSize="21px"
              fontWeight="medium"
              w="100%"
              onClick={onClose}
              _hover={{ color: '#B3B6F7' }}
              fontFamily="marketingPage">
              Menu
            </Text>
            {NAV_LINKS.map((link, idx) => (
              <Text
                key={idx}
                color="text.lightGrey"
                fontSize="16px"
                fontWeight="normal"
                fontFamily="marketingPage"
                w="100%"
                cursor={link.href !== '#' ? 'pointer' : 'default'}
                onClick={() => {
                  if (link.href !== '#') {
                    navigate(link.href);
                    onClose();
                  }
                }}
                _hover={link.href !== '#' ? { color: '#B3B6F7' } : {}}>
                {link.label}
              </Text>
            ))}
            {IS_DEV && (
              <Flex
                align="center"
                mt={4}
                gap={2}
                cursor="pointer"
                onClick={() => onLoginClick(true)}
                _hover={{ color: '#B3B6F7' }}>
                <Icon
                  iconName="login"
                  width={6}
                  height={6}
                  color={'transparent'}
                />
                <Text
                  color="white"
                  fontWeight="semibold"
                  fontFamily="marketingPage"
                  fontSize="16px">
                  Log In
                </Text>
              </Flex>
            )}
          </VStack>
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  );
};

export default MobileDrawerMenu;
